<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Sample Test', apiMethod: 'SampleTests', form: () => import('../forms/SampleTestForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Test Result', apiMethod: 'TestResults', parentForeignKey: 'sampleTestId', form: () => import('../forms/TestResultForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Test Results', value: 'sampleTestId', isCard: true, table: () => import('../tables/TestResultsTable') },
                ],
                mainForm: () => import('../forms/SampleTestForm'),
                claimName: 'SampleTests',
                apiMethod: 'SampleTests',
            }
        }
    };
</script>
